/** ----------------------------------------
 File Input
 ---------------------------------------- */

export default class FileInput {

    constructor(element) {
        this.elem = element;
        this.inputEl = element.querySelector('input[type="file"]');
        this.messageEl = element.querySelector('.form-file__message');

        this.uploadedFileElems = element.querySelectorAll('.js-file-uploaded-file');
        this.hasFilesClass = 'has-files';
        this.init();
    }

    setFileEvent() {
        this.inputEl.addEventListener('change', (e) => {
            if (!e.target.files) return;

            const files = e.target.files;
            const formattedSize = this.getFormattedFilesSize(files);

            this.messageEl.innerHTML = `${ files[0].name } (${ formattedSize })`;
        });
    }

    setRemoveEvent() {
        for (const uploadedFile of this.uploadedFileElems) {
            const removeEl = uploadedFile.querySelector('input[type="checkbox"]');

            removeEl.addEventListener('change', () => {
                uploadedFile.style.display = 'none';

                const activeUploadedFiles = Array.from(this.uploadedFileElems).filter(element => element.style.display !== 'none');

                if (!activeUploadedFiles.length) {
                    this.elem.classList.remove(this.hasFilesClass);
                }
            });
        }
    }

    getFormattedFilesSize(files) {
        let size = 0;
        Array.from(files).forEach(file => size += file.size);
        return this.getFormattedBytes(size);
    }

    getFormattedBytes(bytes, decimals = 1) {
        if (bytes === 0) return '0 Bytes';

        const k = 1024;
        const dm = decimals < 0 ? 0 : decimals;
        const sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'];

        const i = Math.floor(Math.log(bytes) / Math.log(k));

        return parseFloat((bytes / Math.pow(k, i)).toFixed(dm)) + ' ' + sizes[i];
    }

    /** ----------------------------------------
     Init
     ---------------------------------------- */

    init() {
        this.setFileEvent();
        this.setRemoveEvent();
    }
}
